import { boolean, nativeEnum, object } from 'zod';

import { FulfillmentChannel } from './fulfillment-channel-constraint.types';

export const FulfillmentChannelConstraintSchema = object({
  isEnabled: boolean(),
  channel: nativeEnum(FulfillmentChannel),
});
